// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from 'react-router-dom';
// import { Helmet } from "react-helmet-async";
// import { getRequest, postRequest } from "../../services/api";
// import "./Profile.css";

// const Profile = () => {
//   const [profile, setProfile] = useState<any>(null);
//   const [formData, setFormData] = useState<any>({});
//   const [isEditing, setIsEditing] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const storedUser = localStorage.getItem("user");
//         if (!storedUser) {
//             navigate("/");
//             return;
//         }
//         const user = JSON.parse(storedUser);
//         const res = await getRequest(`/auth/profile/${user.id}`, {}, true);
//         setProfile(res.data);
//         setFormData(res.data);
//       } catch (err) {
//         console.error("Error fetching profile:", err);
//         navigate("/");
//       }
//     };
//     fetchProfile();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleUpdate = async () => {
//     try {
//       await postRequest(`/auth/update-profile`, formData);
//       setProfile(formData);
//       setIsEditing(false);
//       alert("Profile updated successfully!");
//     } catch (err) {
//       console.error("Update failed:", err);
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Profile Dashboard - Acadebility</title>
//       </Helmet>

//       {/* Header with toggle button only for mobile */}
//       <div className="d-md-none bg-dark text-white mt-5 p-2 d-flex align-items-center">
//         <button
//           className="btn btn-outline-light me-2"
//           onClick={() => setIsSidebarOpen(!isSidebarOpen)}
//         >
//           ☰
//         </button>
//         <h5 className="m-0">{profile?.firstname} {profile?.lastname}</h5>
//       </div>

//       <div className="d-flex">
//         {/* Sidebar */}
//         <nav
//           className={`sidebar bg-dark text-white p-3 ${
//             isSidebarOpen ? "open" : ""
//           }`}
//         >
//           {/* <h4 className="mb-4 d-none d-md-block">Acadebility</h4> */}
//           <ul className="nav flex-column text-left">
//             <li className="nav-item">
//                 <Link className="nav-link text-white" to="/dashboard">📊 Dashboard</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link text-white active" to="/profile">👤 Profile</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link text-white" to="/tests">📝 My Tests</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link text-white" to="/blogs/all-blogs/test_series">📝 Test Series</Link>
//             </li>
//             <li className="nav-item">
//               <Link className="nav-link text-white" to="/change-password">🔑 Change Password</Link>
//             </li>
//             {/* <li className="nav-item">
//               <Link className="nav-link text-white" to="/settings">⚙️ Settings</Link>
//             </li> */}
//           </ul>
//         </nav>

//         {/* Main content */}
//         <div className="content flex-grow-1 p-4">
//           <div className="card shadow-sm">
//             <div className="card-body">
//               <div className="row">
//                 {/* Left profile card */}
//                 <div className="col-md-4 text-center border-right mb-3 mb-md-0">
//                   <img
//                     src="https://bootdey.com/img/Content/avatar/avatar7.png"
//                     alt="User Avatar"
//                     className="rounded-circle mb-3"
//                     width="120"
//                   />
//                   <h4>{profile?.firstname} {profile?.lastname}</h4>
//                   <p className="text-muted">{profile?.occupation}</p>
//                   <button className="btn btn-outline-primary btn-sm me-2">Follow</button>
//                   <button className="btn btn-outline-secondary btn-sm">Message</button>
//                 </div>

//                 {/* Right profile info */}
//                 <div className="col-md-8">
//                   <h5 className="mb-3">Profile Information</h5>
                  
//                   <div className="row mb-2">
//                     <div className="col-sm-4 fw-bold">Email:</div>
//                     <div className="col-sm-8">
//                       <input
//                         type="text"
//                         className="form-control-plaintext"
//                         value={formData.email || ""}
//                         disabled
//                       />
//                     </div>
//                   </div>

//                   <div className="row mb-2">
//                     <div className="col-sm-4 fw-bold">Mobile:</div>
//                     <div className="col-sm-8">
//                       <input
//                         type="text"
//                         name="mobile"
//                         className={`form-control ${!isEditing ? "border-0 bg-transparent p-0" : ""}`}
//                         value={formData.mobile || ""}
//                         onChange={handleChange}
//                         disabled={!isEditing}
//                       />
//                     </div>
//                   </div>

//                   <div className="row mb-2">
//                     <div className="col-sm-4 fw-bold">Address:</div>
//                     <div className="col-sm-8">
//                       <input
//                         type="text"
//                         name="address"
//                         className={`form-control ${!isEditing ? "border-0 bg-transparent p-0" : ""}`}
//                         value={formData.address || ""}
//                         onChange={handleChange}
//                         disabled={!isEditing}
//                       />
//                     </div>
//                   </div>

//                   {!isEditing ? (
//                     <button
//                       className="btn btn-primary mt-3"
//                       onClick={() => setIsEditing(true)}
//                     >
//                       Edit
//                     </button>
//                   ) : (
//                     <div className="mt-3">
//                       <button
//                         className="btn btn-success me-2"
//                         onClick={handleUpdate}
//                       >
//                         Save
//                       </button>
//                       <button
//                         className="btn btn-secondary"
//                         onClick={() => {
//                           setIsEditing(false);
//                           setFormData(profile);
//                         }}
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div> 
//     </>
//   );
// };

// export default Profile;
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { getRequest, postRequest } from "../../services/api";
import DashboardLayout from "../DashboardLayout/DashboardLayout";
import "./Profile.css";

const Profile: React.FC = () => {
  const [profile,    setProfile]    = useState<any>(null);
  const [formData,   setFormData]   = useState<any>({});
  const [isEditing,  setIsEditing]  = useState(false);
  const [saving,     setSaving]     = useState(false);
  const [msgInfo,    setMsgInfo]    = useState<string | null>(null);
  const [msgOk,      setMsgOk]      = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const stored = localStorage.getItem("user");
        if (!stored) { navigate("/"); return; }
        const user = JSON.parse(stored);
        const res = await getRequest(`/auth/profile/${user.id}`, {}, true);
        setProfile(res.data);
        setFormData(res.data);
      } catch {
        navigate("/");
      }
    };
    fetchProfile();
  }, [navigate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    setSaving(true);
    setMsgInfo(null);
    try {
      await postRequest("/auth/update-profile", formData);
      setProfile(formData);
      setIsEditing(false);
      setMsgOk(true);
      setMsgInfo("Profile updated successfully!");
    } catch {
      setMsgOk(false);
      setMsgInfo("Update failed. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const fullName = profile ? `${profile.firstname || ""} ${profile.lastname || ""}`.trim() : "";
  const initials = fullName
    ? fullName.split(" ").map((n: string) => n[0]).join("").toUpperCase().slice(0, 2)
    : "A";

  const PROFILE_FIELDS = [
    { label: "First Name",  name: "firstname", type: "text",  editable: true  },
    { label: "Last Name",   name: "lastname",  type: "text",  editable: true  },
    { label: "Email",       name: "email",     type: "email", editable: false },
    { label: "Mobile",      name: "mobile",    type: "text",  editable: true  },
    { label: "Address",     name: "address",   type: "text",  editable: true  },
  ];

  return (
    <>
      <Helmet><title>Profile - Acadebility</title></Helmet>
      <DashboardLayout pageTitle="My Profile" activePath="/profile">

        <div className="prf-grid">

          {/* ── Left: avatar card ── */}
          <div className="prf-avatar-card dsh-card">
            <div className="prf-avatar-ring">
              <div className="prf-avatar-initials">{initials}</div>
            </div>
            <h2 className="prf-name">{fullName || "—"}</h2>
            <p className="prf-email">{profile?.email || ""}</p>

            <div className="prf-badge-row">
              <span className="prf-badge prf-badge-active">Active</span>
              <span className="prf-badge prf-badge-free">Free Plan</span>
            </div>

            <div className="prf-stats-mini">
              <div className="prf-stat-mini">
                <div className="prf-stat-mini-val">—</div>
                <div className="prf-stat-mini-label">Tests Taken</div>
              </div>
              <div className="prf-stat-mini-divider" />
              <div className="prf-stat-mini">
                <div className="prf-stat-mini-val">—</div>
                <div className="prf-stat-mini-label">Submitted</div>
              </div>
              <div className="prf-stat-mini-divider" />
              <div className="prf-stat-mini">
                <div className="prf-stat-mini-val">—</div>
                <div className="prf-stat-mini-label">Score Avg</div>
              </div>
            </div>

            <div className="prf-member-since">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              Member since {new Date().getFullYear()}
            </div>
          </div>

          {/* ── Right: info card ── */}
          <div className="prf-info-card dsh-card">
            <div className="prf-info-head">
              <div>
                <h3 className="prf-info-title">Profile Information</h3>
                <p className="prf-info-sub">Keep your details up to date</p>
              </div>
              {!isEditing ? (
                <button className="prf-edit-btn" onClick={() => setIsEditing(true)}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                  </svg>
                  Edit Profile
                </button>
              ) : (
                <div className="prf-action-btns">
                  <button className="prf-save-btn" onClick={handleUpdate} disabled={saving}>
                    {saving ? <><span className="prf-spinner" /> Saving…</> : "Save Changes"}
                  </button>
                  <button className="prf-cancel-btn" onClick={() => { setIsEditing(false); setFormData(profile); }}>
                    Cancel
                  </button>
                </div>
              )}
            </div>

            {msgInfo && (
              <div className={`prf-alert${msgOk ? " prf-alert-ok" : " prf-alert-err"}`}>
                {msgOk ? "✅" : "⚠️"} {msgInfo}
              </div>
            )}

            <div className="prf-fields-grid">
              {PROFILE_FIELDS.map(f => (
                <div className="prf-field" key={f.name}>
                  <label className="prf-field-label">{f.label}</label>
                  <div className="prf-field-input-wrap">
                    <input
                      type={f.type}
                      name={f.name}
                      className={`prf-field-input${isEditing && f.editable ? " prf-field-input-active" : ""}${!f.editable ? " prf-field-input-disabled" : ""}`}
                      value={formData[f.name] || ""}
                      onChange={handleChange}
                      disabled={!isEditing || !f.editable}
                      placeholder={`Enter ${f.label.toLowerCase()}`}
                    />
                    {!f.editable && (
                      <span className="prf-field-lock">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                        </svg>
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Security section */}
            <div className="prf-security-block">
              <div className="prf-security-title">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                Security
              </div>
              <div className="prf-security-row">
                <div>
                  <div className="prf-security-label">Password</div>
                  <div className="prf-security-hint">Last changed: —</div>
                </div>
                <a href="/change-password" className="prf-change-pwd-btn">Change Password</a>
              </div>
            </div>
          </div>

        </div>
      </DashboardLayout>
    </>
  );
};

export default Profile;
